module.exports = __webpack_public_path__ + "static/media/button.fe18fbcc.png";